import {
  validateEmail as validateEmailStrict,
  isValidEmail,
  EMAIL_REGEX,
} from "./emailValidation.js";

export type ValidationResult = string | null;

export { isValidEmail, EMAIL_REGEX };

export const validateRequired = (value: string | undefined | null, label: string): ValidationResult => {
  const trimmed = (value ?? "").toString().trim();
  if (!trimmed) {
    return `${label} is required`;
  }
  return null;
};

export const validateEmail = (value: string | undefined | null): ValidationResult =>
  validateEmailStrict(value);

export const validatePhone = (value: string | undefined | null): ValidationResult => {
  const digits = (value ?? "").toString().replaceAll(/\D/g, "");
  if (!digits) {
    return "Phone number is required";
  }
  if (digits.length < 7 || digits.length > 15) {
    return "Invalid phone number";
  }
  return null;
};

export const validatePassword = (
  value: string | undefined | null,
  minLength = 6
): ValidationResult => {
  const trimmed = (value ?? "").toString().trim();
  if (!trimmed) {
    return "Password is required";
  }
  if (trimmed.length < minLength) {
    return `Password must be at least ${minLength} characters`;
  }
  return null;
};
